import React from 'react';

const AttendanceTable = ({ attendanceData }) => {
  const attendance = attendanceData?.attendance || {};

  const rows = Object.entries(attendance).flatMap(([driverId, records]) =>
    records.map(record => ({
      driverId,
      driverName: record.driver?.user?.username || '',
      supervisorName: record.driver?.supervisor?.user?.username || '',
      date: record.date,
      startKm: record.start_km,
      endKm: record.end_km,
      startTime: new Date(record.start_time).toLocaleString(),
      endTime: record.end_time ? new Date(record.end_time).toLocaleString() : 'Ongoing',
      onlineTime: new Date(record.online_time).toLocaleString(),
      offlineTime: record.offline_time ? new Date(record.offline_time).toLocaleString() : 'N/A',
      online: record.online ? 'Yes' : 'No',
    }))
  );

  return (
    <div className="table-responsive">
      <table className="table table-bordered table-striped">
        <thead className="table-dark">
          <tr>
            <th>Driver ID</th>
            <th>Driver Name</th>
            <th>Supervisor</th>
            <th>Date</th>
            <th>Start KM</th>
            <th>End KM</th>
            <th>Start Time</th>
            <th>End Time</th>
            <th>Online Time</th>
            <th>Offline Time</th>
            <th>Online</th>
          </tr>
        </thead>
        <tbody>
          {rows.length > 0 ? (
            rows.map((row, idx) => (
              <tr key={idx}>
                <td>{row.driverId}</td>
                <td>{row.driverName}</td>
                <td>{row.supervisorName}</td>
                <td>{row.date}</td>
                <td>{row.startKm}</td>
                <td>{row.endKm}</td>
                <td>{row.startTime}</td>
                <td>{row.endTime}</td>
                <td>{row.onlineTime}</td>
                <td>{row.offlineTime}</td>
                <td>{row.online}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="11" className="text-center">
                No attendance records found.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default AttendanceTable;
